import { Helmet } from 'react-helmet-async';
import EmentaCreateView from 'src/sections/ementas/view/ementas-create-view';

export default function EmentasCreatePage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Ementas</title>
      </Helmet>

      <EmentaCreateView />
    </>
  );
}
